import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const waveAccounting = defineConnector({
  identifier: "waveAccounting",
  name: "Wave Accounting",
  tagLine: "Small business accounting",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://gql\\.waveapps\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Wave Accounting app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Wave Developer Portal](https://developer.waveapps.com/) and navigate to **My Apps** to create a new application and get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/waveAccounting/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Wave Accounting account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Wave Accounting account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.waveapps.com/oauth2/authorize",
    tokenEndpoint: () => "https://api.waveapps.com/oauth2/token/",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://gql.waveapps.com/graphql/public",
  },
});
